(ns machtfit.product-form.how-much
  (:require [cljs.core.match :refer [match]]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.employee-rules-table :refer [employee-rules-table]]
            [machtfit.human :as human]
            [machtfit.product-form.core :as product-form]
            [machtfit.product-form.how :as how]
            [machtfit.product-form.review :as review]
            [machtfit.product-form.section :refer [show-next-section]]
            [machtfit.product-form.validation :as validation]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(rf/reg-event-db ::set-vat
  (fn [db [_ new-vat]]
    (-> db
        (assoc-in [:product :how-much :vat] new-vat)
        (assoc-in [:ui :last-focused-config-section] :how-much))))

(defn- -handle-amount [[event & args] amount]
  (case event
    :change (first args)
    :blur (widgets/clean-amount amount)))

(rf/reg-event-db ::handle-amount
  (fn [db [_ path event-and-args]]
    (update-in db path (partial -handle-amount event-and-args))))

(defn- amount []
  [widgets/amount-input
   {:id "amount"
    :label-text "Preis"
    :value @(rf/subscribe [:get [:product :how-much :amount]])
    :required? true
    :input-style {:font-size "2rem" :text-align "right"}
    :handler #(rf/dispatch [::handle-amount [:product :how-much :amount] %])}])

(defn- vat []
  [:div
   [widgets/radio-options
    {:name "vat"
     :current-value @(rf/subscribe [:get [:product :how-much :vat]])
     :choices @(rf/subscribe [:get [:ui :vat-options]])
     :on-select #(rf/dispatch [::set-vat %])}]])

(defn- price-given []
  [:div.col.s12 {:style {:margin-bottom "1rem"}}
   [:input.filled-in {:type "checkbox"
                      :id "price-given"
                      :checked @(rf/subscribe [:get [:product :how-much :price-given?]])
                      :on-change #(rf/dispatch [:toggle [:product :how-much :price-given?]])}]
   [:label.black-text {:for "price-given"
                       :style {:height "auto"
                               :line-height "normal"}}
    "Das Angebot hat einen Preis"]])

(defn- commission []
  (let [{:keys [type rate_100 effective]} @(rf/subscribe [:get [:ui :supplier :commission-plan]])]
    [:div
     [:div.col.s1 {:style {:margin-top "0.5rem"}}
      [widgets/block-input2 {:id "commission"
                             :label-text "Provision"
                             :value @(rf/subscribe [:get [:product :how-much :commission]])
                             :on-save #(rf/dispatch [:set-path [:product :how-much :commission] %])}]]
     (when-not (= type "none")
       [:div.col {:style {:margin-top "2.3rem"}}

        (let [nbsp "\u00A0"]
          (str "(abweichend " rate_100 nbsp "% "))

        (case type
          "timeplan" (str "bis zum " effective)
          "quantityplan" (str "für die "
                              "nächste" (when-not (= effective 1) "n") " "
                              effective
                              " Buchung" (when-not (= effective 1) "en")))
        " nach Provisionsplan.)"])]))

(rf/reg-event-db ::set-max-bookings-value
  (fn [db [_ new-value min-value]]
    (-> db
        (assoc-in [:product :how-much :max-bookings]
                  (let [v (if (int new-value) (int new-value) min-value)]
                    {:choice (if (>= v min-value) :set :unset) :value v}))
        (assoc-in [:ui :last-focused-config-section] :how-much))))

(rf/reg-event-db ::set-max-bookings-choice
  (fn [db [_ new-choice min-value]]
    (-> db
        (update-in [:product :how-much :max-bookings]
                   #(case new-choice
                      :set {:choice :set
                            :value (max (:value %) min-value)}
                      :unset {:choice :unset
                              :value (:value %)}))
        (assoc-in [:ui :last-focused-config-section] :how-much))))

(defn- max-bookings []
  (let [num-participants @(rf/subscribe [:get [:ui :num-participants]])
        [intro unset set-intro set-outro outro]
        (if @(rf/subscribe [:get [:options :partner-product?]])
          ["Das Angebot darf"
           (if @(rf/subscribe [::how/needs-access-code?])
             (str "bis die " @(rf/subscribe [::how/access-code-name]) "s alle sind")
             "unbegrenzt")
           "insgesamt höchstens"
           " Mal"
           "über machtfit gebucht werden."]

          ["Auf das Angebot dürfen sich"
           "unbegrenzt viele Teilnehmer"
           "höchstens"
           " Teilnehmer"
           "über machtfit anmelden."])
        {:keys [choice value]} @(rf/subscribe [:get [:product :how-much :max-bookings]])]
    [:div.valign-wrapper
     [widgets/choice {:name "max-bookings"
                      :intro intro
                      :choices [[:unset unset]
                                [:set [:span
                                       set-intro
                                       [widgets/inline-input {:value (case choice :set value "")
                                                              :validators [validation/positive-number]
                                                              :required? false
                                                              :on-save #(rf/dispatch [::set-max-bookings-value % num-participants])}]
                                       set-outro]]]
                      :on-select #(rf/dispatch [::set-max-bookings-choice % num-participants])
                      :current-choice choice
                      :outro outro}]]))

(defn- constraints []
  (let [num-participants @(rf/subscribe [:get [:ui :num-participants]])]
    [:div.col.s12
     [:label {:style {:margin-top "1rem" :font-size "12px" :display "block"}} "Beschränkung"]
     [max-bookings]
     [:div {:style {:margin-top "1rem"}}
      (if @(rf/subscribe [:get [:options :partner-product?]])
        (case num-participants
          0 "Bisher hat niemand das Angebot über machtfit gebucht."
          (str
           "Das Angebot wurde bereits "
           num-participants
           " Mal über machtfit gebucht."))
        (case num-participants
          0 "Es hat sich noch niemand über machtfit auf das Angebot angemeldet."
          1 (str "Auf das Angebot hat sich bereits " num-participants " Teilnehmer über machtfit angemeldet.")
          (str "Auf das Angebot haben sich bereits " num-participants " Teilnehmer über machtfit angemeldet.")))]]))

(defn- suggested-retail-amount []
  (let [machtfit-admin? @(rf/subscribe [::product-form/machtfit-admin?])
        suggested-retail-price @(rf/subscribe [:get [:product :how-much :suggested-retail-price]])
        price-cents (some-> @(rf/subscribe [:get [:product :how-much :amount]]) human/human->amount human/amount->cents)
        suggested-retail-price-cents (some-> suggested-retail-price human/human->amount human/amount->cents)]
    [:div.row {:style {:margin-left "0.2rem"}}
     (when-not machtfit-admin? [:p.col.s12 "Kann nur von Machtfit geändert werden."])
     [:div.col {:style {:margin-top "1rem"
                        :width "15%"}}
      [widgets/amount-input {:id "suggested-retail-amount"
                             :value suggested-retail-price
                             :label-text "Preisempfehlung"
                             :input-style {:font-size "1rem" :text-align "right"}
                             :disabled (not machtfit-admin?)
                             :handler #(rf/dispatch [::handle-amount [:product :how-much :suggested-retail-price] %])}]]
     [:div.col {:style {:margin-top "1rem"
                        :padding-left 0}}
      [:div.input-field {:style {:padding-top "0.7rem"}}
       [:span {:style {:font-size "1rem"}} "€"]]]
     (when (and
            price-cents
            suggested-retail-price-cents
            (<= suggested-retail-price-cents price-cents))
       [:div.col.12
        [:p {:style {:color "red"}} "UVP ist nicht größer als der Listenpreis und wird daher nicht angezeigt."]])]))

(rf/reg-sub ::schedule-type
  :<- [:get [:product :when :has-schedule?]]
  :<- [:get [:product :when :sessions-per-signup]]
  :<- [:get [:product :when :cohesion]]

  (fn [[has-schedule? sessions-per-signup cohesion] _]
    (match [has-schedule? sessions-per-signup cohesion]
      [true :one-session _] :single
      [true :multiple-sessions :independent] :independent
      [true :multiple-sessions :progressive] :progressive
      :else nil)))

(rf/reg-sub ::can-decide-on-price-given?
  :<- [:get [:product :what :bookable?]]
  :<- [:get [:options :company-product?]]

  (fn [[bookable? company-product?] _]
    (or company-product? (not bookable?))))

(rf/reg-event-db ::add-subsidy-rule
  (fn [db [_ rule]]
    (update-in db [:product :how-much :subsidies] #(conj (if (empty? %) [] %) rule))))

(rf/reg-event-db ::delete-subsidy-rule
  (fn [db [_ index]]
    (update-in db [:product :how-much :subsidies] utils/delete-at index)))

(rf/reg-event-db ::set-subsidy-condition
  (fn [db [_ index condition value]]
    (update-in db [:product :how-much :subsidies index :condition]
               #(if (or (and (coll? value) (empty? value)) (nil? value))
                  (dissoc % condition)

                  (assoc % condition value)))))

(rf/reg-event-db ::set-subsidy-result
  (fn [db [_ index value]]
    (assoc-in db [:product :how-much :subsidies index :result :subsidy-rate] value)))

(rf/reg-sub ::nil-subscription
  (fn [_ _]
    nil))

(rf/reg-sub ::product-subsidies?
  :<- [:get [:product :how-much :subsidies]]

  (fn [subsidies _]
    (empty? subsidies)))

(defn- subsidy-for []
  [:div
   [:div.divider.col.s12]
   [:div.col.s12>h5 {:style {:margin "20px 0"}} "Spezielle Bezuschussungsregeln"]
   [:div.col.s12
    [employee-rules-table {:id :subsidy-for
                           :allow-no-rules? true
                           :rules-must-match-admin-rules? false
                           :placeholder-text [:<>
                                              [:p "Das Angebot wird nach den Bezuschussungsregeln der jeweiligen Firmen bezuschusst."]
                                              [:p "Sie können das Angebot auch nur für bestimmte Mitarbeiter anders bezuschussen, indem Sie nachfolgend Bedingungen für diese Mitarbeiter angeben."]]
                           :rules-sub [:get [:product :how-much :subsidies]]
                           :companies-sub [:get [:ui :employee-rules :condition-options :companies]]
                           :places-of-business-sub [:get [:ui :employee-rules :condition-options :places-of-business]]
                           :employee-groups-sub [:get [:ui :employee-rules :condition-options :employee-groups]]
                           :subsidiaries-sub [:get [:ui :employee-rules :condition-options :subsidiaries]]
                           :occupation-groups-sub [:get [:ui :employee-rules :condition-options :occupation-groups]]
                           :managed-employees-sub [::nil-subscription]
                           :new-rule-template {:result {:subsidy-rate 0}}
                           :on-delete-rule ::delete-subsidy-rule
                           :on-add-rule ::add-subsidy-rule
                           :on-set-rule-condition ::set-subsidy-condition
                           :on-set-rule-result ::set-subsidy-result
                           :places-of-business-selective-intro-text "Das Angebot wird"
                           :places-of-business-selective-outro-text "bezuschusst."
                           :places-of-business-not-selective-text "an allen (auch zukünftigen) Standorten"
                           :places-of-business-selective-text "nur an ausgewählten Standorten"
                           :employee-groups-selective-intro-text "Das Angebot wird"
                           :employee-groups-selective-outro-text "angezeigt."
                           :employee-groups-not-selective-text "allen (auch zukünftigen) Mitarbeitergruppen"
                           :employee-groups-selective-text "nur ausgewählten Mitarbeitergruppen"}]
    (when-not @(rf/subscribe [::product-subsidies?])
      [:div {:style {:margin "20px 0"}} "Für hier nicht erfasste Mitarbeiter gelten die allgemeinen Bezuschussungsregeln der jeweiligen Unternehmen."])]])

(defn- number-of-appointments-input []
  [widgets/inline-input
   {:value @(rf/subscribe [:get [:product :how-much :number-of-appointments]])
    :required? true
    :validators [validation/positive-number]
    :placeholder "z.B. 8"
    :on-save #(rf/dispatch [:set-path [:product :how-much :number-of-appointments] %])}])

(defn- validity-period-input []
  [widgets/inline-input
   {:value @(rf/subscribe [:get [:product :how-much :validity-period]])
    :required? true
    :validators [validation/positive-number]
    :style {:width "8rem"}
    :placeholder "z.B. 4"
    :on-save #(rf/dispatch [:set-path [:product :how-much :validity-period] %])}])

(defn- number-of-appointments-and-validity-period []
  (when @(rf/subscribe [:get [:product :how-much :price-given?]])
    [:div.col.s12 {:style {:margin-bottom "0.5rem"}}
     (cond
       (= @(rf/subscribe [::schedule-type])
          :independent) [:span
                         "Darin sind "
                         [number-of-appointments-input]
                         " Termine enthalten, die innerhalb von "
                         [validity-period-input]
                         " Wochen ab Kaufdatum in Anspruch genommen werden können."]
       (and @(rf/subscribe [:get [:product :what :p20-certified?]])
            (not @(rf/subscribe [:get [:product :when :has-schedule?]]))) [:span "Angebot muss innerhalb von "
                                                                           [validity-period-input]
                                                                           " Wochen ab Kaufdatum in Anspruch genommen werden."])]))

(defn section-how-much []
  (let [partner-product? @(rf/subscribe [:get [:options :partner-product?]])
        price-given? @(rf/subscribe [:get [:product :how-much :price-given?]])
        can-decide-on-price-given? @(rf/subscribe [::can-decide-on-price-given?])
        can-decide-commission? @(rf/subscribe [:get [:options :can-decide-commission?]])
        registration-needed? @(rf/subscribe [:get [:product :how :registration-needed?]])
        current-registration-type @(rf/subscribe [:get [:product :how :registration-type]])
        current-schedule-type @(rf/subscribe [::schedule-type])
        machtfit-admin? @(rf/subscribe [::product-form/machtfit-admin?])
        has-suggested-retail-price? (not (nil? @(rf/subscribe [:get [:product :how-much :suggested-retail-price]])))]
    [widgets/section
     {:anchor "how-much"
      :title [review/highlighted-section-title :how-much "Wieviel"]
      :subtitle [:div "kostet die Teilnahme?"
                 [review/field-badges :how-much]]
      :content [:div
                (when can-decide-on-price-given?
                  [price-given])
                (when (or (not can-decide-on-price-given?) price-given?)
                  [:div
                   (when (and partner-product? (or machtfit-admin? has-suggested-retail-price?))
                     [suggested-retail-amount])
                   [:div.col
                    {:style {:margin-bottom "0.5rem"
                             :padding-right "0.2rem"
                             :width "15%"}}
                    [amount]]
                   [:div.col {:style {:padding-left "0.1rem"}}
                    [:div.input-field
                     [:span {:style {:font-size "2rem"}} "€"]]]
                   [:div.col {:style {:margin-bottom "1rem"}} [vat]]])
                [number-of-appointments-and-validity-period]
                (when can-decide-commission?
                  [commission])
                (when (and registration-needed?
                           (= current-registration-type :machtfit)
                           (or (nil? current-schedule-type)
                               (= current-schedule-type :independent)))
                  [constraints])
                (when (and partner-product? machtfit-admin?)
                  [subsidy-for])
                [show-next-section :how-much]]}]))
